<template>
  <tr class="bg-green-50 dark:bg-green-900/30 border-l-4 border-green-500">
    <!-- Checkbox placeholder -->
    <td class="px-3 py-3">
      <div class="w-5 h-5 flex items-center justify-center">
        <i class="fas fa-plus text-green-500 text-sm"></i>
      </div>
    </td>
    
    <!-- Sipariş Seçimi -->
    <td class="px-3 py-3">
      <div class="relative">
        <select
          v-model="selectedOrder"
          class="w-full bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200"
          :class="{'border-red-300': !selectedOrder && showValidation}"
        >
          <option value="">Sipariş Seçin</option>
          <option v-for="item in order" :key="item.orderNo" :value="item.orderNo">
            {{ item.orderNo }} - {{ item.name }}
          </option>
        </select>
        <div v-if="!selectedOrder && showValidation" class="absolute -bottom-5 left-0 text-xs text-red-500">
          Sipariş seçimi zorunlu
        </div>
      </div>
    </td>
    
    <!-- Araç Seçimi -->
    <td class="px-3 py-3">
      <div class="relative">
        <vehicleSelect
          v-if="selectedOrder > 0"
          v-model="vehicle"
          :optList="getFilterVehicle"
          :order="selectedOrderDetail"
          :products="products"
          :customers="customers"
          :load="vehicleLoad"
          :isBulk="true"
          :sorted="true"
          :warningControl="true"
          :selectedVehicles="selectedVehicles"
          @isVehicleConflictModalVisible="(val)=>$emit('isVehicleConflictModalVisible',val)"
        />
        <div v-else class="text-sm text-gray-400 italic py-2">
          Önce sipariş seçin
        </div>
        <div v-if="selectedOrder && !vehicle && showValidation" class="absolute -bottom-5 left-0 text-xs text-red-500">
          Araç seçimi zorunlu
        </div>
      </div>
    </td>
    
    <!-- Adres -->
    <td class="px-3 py-3">
      <div class="text-sm text-gray-600 dark:text-gray-300">
        <span v-if="vehicle?.address">
          <i class="fas fa-map-marker-alt text-gray-400 mr-1"></i>
          {{ vehicle.address }}
        </span>
        <span v-else class="text-gray-400 italic">--</span>
      </div>
    </td>
    
    <!-- Yıkama Noktası -->
    <td class="px-3 py-3">
      <div class="text-sm text-gray-600 dark:text-gray-300">
        <span v-if="vehicle?.washPointName">
          <i class="fas fa-water text-blue-400 mr-1"></i>
          {{ vehicle.washPointName }}
        </span>
        <span v-else class="text-gray-400 italic">--</span>
      </div>
    </td>
    
    <!-- Yıkama Maliyeti -->
    <td class="px-3 py-3">
      <div class="text-sm">
        <span v-if="vehicle?.washCost >= 0" class="text-blue-600 dark:text-blue-400 font-medium">
          <i class="fas fa-lira-sign text-xs mr-1"></i>
          {{ Number(vehicle.washCost).toLocaleString() }}
        </span>
        <span v-else class="text-gray-400 italic">--</span>
      </div>
    </td>
    
    <!-- Taşıma Maliyeti -->
    <td class="px-3 py-3">
      <div class="text-sm">
        <span v-if="vehicle?.recomendationTotalCost >= 0" class="text-orange-600 dark:text-orange-400 font-medium">
          <i class="fas fa-lira-sign text-xs mr-1"></i>
          {{ Number(vehicle.recomendationTotalCost).toLocaleString() }}
        </span>
        <span v-else class="text-gray-400 italic">--</span>
      </div>
    </td>
    
    <!-- Toplam Maliyet -->
    <td class="px-3 py-3">
      <div class="text-sm">
        <span v-if="vehicle?.allCost !== undefined && vehicle?.allCost !== null" class="text-green-600 dark:text-green-400 font-semibold">
          <i class="fas fa-lira-sign text-xs mr-1"></i>
          {{ Number(vehicle.allCost).toLocaleString() }}
        </span>
        <span v-else class="text-gray-400 italic">--</span>
      </div>
    </td>
    
    <!-- İşlemler -->
    <td class="px-3 py-3" v-if="!hiddenInsert">
      <div class="flex space-x-2">
        <button
          type="button"
          class="w-8 h-8 bg-green-500 hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-md transition-all duration-200 flex items-center justify-center shadow-sm hover:shadow-md"
          @click="addItem"
          :disabled="!vehicle || !selectedOrder || vehicleLoad"
          :title="getButtonTooltip"
        >
          <i v-if="vehicleLoad" class="fas fa-spinner fa-spin text-sm"></i>
          <i v-else class="fas fa-plus text-sm"></i>
        </button>
        <button
          type="button"
          class="w-8 h-8 bg-gray-400 hover:bg-gray-500 text-white rounded-md transition-colors duration-200 flex items-center justify-center shadow-sm hover:shadow-md"
          @click="resetForm"
          title="Formu Temizle"
        >
          <i class="fas fa-times text-sm"></i>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import { calculator } from "@/utils/cost";
import { calculateDistancePriority,isWashStatus,isSequential } from "@/utils/recomendation";
import vehicleSelect from "../../../../../orders/components/vehicle-select.vue";

export default {
  name: "new-vehicle-row",
  props: [
    "order",
    "products",
    "customers",
    "vehicleList",
    "activeList",
    "selectedVehicles",
    "hiddenInsert",
  ],
  components: {
    vehicleSelect,
  },
  data() {
    return {
      vehicle: "",
      vehicleLoad: false,
      selectedOrder: "",
      selectedOrderDetail: {},
      calculationInProgress: false,
      showValidation: false,
    };
  },
  methods: {
    async calculateCost(vehicleParameter) {
      if (
        !this.vehicle ||
        this.calculationInProgress ||
        !this.selectedOrderDetail
      )
        return null;

      this.calculationInProgress = true;

      const distancePriority = calculateDistancePriority(
        this.selectedOrderDetail,
        this.vehicle
      );
      const distance = parseFloat(distancePriority).toFixed(2);

      try {
        const cost = await calculator(
          this.$store.state.userData.token,
          1,
          1,
          vehicleParameter||this.vehicle,
          this.selectedOrderDetail,
          distance,
          0,
          true,
          true,
          1,
          distance / 50
        );

        return {
          ...this.vehicle,
          distance: distance,
          washPointName: cost.washPointName,
          recomendationTotalCost: Number(cost.total),
          washCost: Number(cost.totalWashPriceCost),
          allCost: Number(cost.total) + Number(cost.totalWashPriceCost),
          distanceWithWashing:cost?.distanceWithWashing
        };
      } catch (error) {
        console.error(
          `Failed to calculate cost for vehicle ${
            this.vehicle?.id || "unknown"
          }:`,
          error
        );
        return null;
      } finally {
        this.calculationInProgress = false;
      }
    },

    async addItem() {
      // Show validation if fields are empty
      if (!this.vehicle || !this.selectedOrder) {
        this.showValidation = true;
        setTimeout(() => {
          this.showValidation = false;
        }, 3000);
        return;
      }

      try {
        this.vehicleLoad = true;

        if (!this.vehicle.recomendationTotalCost) {
          const costData = await this.calculateCost();
          if (costData) {
            this.vehicle = { ...this.vehicle, ...costData };
          }
        }

        const item = this.order?.find(
          (item) => item.orderNo == this.selectedOrder
        );
        if (item) {
          this.$emit("addItem", {
            ...this.vehicle,
            orderNo: item.orderNo,
            orderName: item.name,
            outpointLat: item.outpointLat,
            outpointLng: item.outpointLng,
          });
          this.resetForm();
        }
      } catch (error) {
        console.error("Error adding vehicle:", error);
      } finally {
        this.vehicleLoad = false;
      }
    },

    resetForm() {
      this.vehicle = "";
      this.selectedOrder = "";
      this.selectedOrderDetail = {};
      this.showValidation = false;
    },

    async calculateRealDistanceAsync(vehicle) {
      if (!vehicle || !this.selectedOrderDetail) return;

      try {
        const { realRouteDistance } = require('@/utils/recomendation/realRouteDistance');

        const fromLocation = {
          lat: parseFloat(vehicle.latitude || 0),
          lng: parseFloat(vehicle.longitude || 0)
        };

        const orderLocation = {
          lat: parseFloat(this.selectedOrderDetail.outpointLat || 0),
          lng: parseFloat(this.selectedOrderDetail.outpointLng || 0)
        };

        if (!fromLocation.lat || !fromLocation.lng || !orderLocation.lat || !orderLocation.lng) {
          return;
        }

        // Arka planda OSRM mesafesini hesapla ve cache'e kaydet
        await realRouteDistance(fromLocation, orderLocation, true);
      } catch (error) {
        // Hata durumunda sessizce devam et
      }
    },
  },
  computed: {
    getFilterVehicle() {
      return this.vehicleList?.map((item) => ({
        ...item,
        name: item.vehicle,
        isRent: item?.haveType,
      }));
    },
    getButtonTooltip() {
      if (this.vehicleLoad) return "Araç ekleniyor...";
      if (!this.selectedOrder) return "Önce sipariş seçin";
      if (!this.vehicle) return "Önce araç seçin";
      return "Aracı Ekle";
    },
  },
  watch: {
    selectedOrder(val) {
      const item = this.order?.find((item) => item.orderNo == val);
      this.selectedOrderDetail = item || {};
    },
    vehicle: {
      async handler(newValue, oldValue) {

         const order = this.order?.find((item) => item.orderNo == this.selectedOrder);
        if (
          newValue &&
          this.selectedOrderDetail &&
          (!newValue.recomendationTotalCost || !newValue.washCost) &&
          JSON.stringify(newValue) !== JSON.stringify(oldValue)
        ) {

          let vehicleFromVehicleList = this.vehicleList.find((item) => item.plate === this.vehicle.plate)
          const isVehicleSequel = vehicleFromVehicleList.orderNos.length > 0 
                              ? isSequential(vehicleFromVehicleList, {
                                ...order,
                                startLat : order.outpointLat,
                                startLng : order.outpointLng,
                                endLat : order.targetPointLat,
                                endLng : order.targetPointLng,
                              })
                              : false;  
          const vehicleWashStatus=isWashStatus(
              this.customers,
              this.products,
              {...vehicleFromVehicleList,isSequentialTrue:isVehicleSequel},
              order
            ).status

          // OSRM mesafesini arka planda hesapla ve cache'e kaydet
          this.calculateRealDistanceAsync(vehicleFromVehicleList);

          const costData = await this.calculateCost(
            {...vehicleFromVehicleList, recomendation:{
            isWashing: vehicleWashStatus
            }}
          );
          if (costData) {
            this.vehicle = { ...this.vehicle, ...costData };
          }
        }
      },
      deep: true,
    },
  },
};
</script>
